export default __webpack_public_path__ + "static/media/house-1.e63e4a2c.jpg";